import __vue_component__$1 from '../Button/Button.vue.js';
import CopyIcon from '../Icon/CopyIcon.js';
import __vue_component__ from '../Tooltip/Tooltip.vue.js';

//
var script = {
  name: 'CopyToClipboard',
  components: {
    Tooltip: __vue_component__,
    Button: __vue_component__$1,
    CopyIcon
  },
  props: {
    appearance: {
      type: String,
      default: 'subtle'
    },
    spacing: {
      type: String,
      default: 'subtle'
    },
    text: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: 'Copy to clipboard'
    },
    placement: {
      type: String,
      default: 'bottom'
    }
  },

  data() {
    return {
      copied: false,
      timeout: undefined
    };
  },

  computed: {
    tooltip() {
      return this.copied ? 'Copied' : this.label;
    }

  },

  beforeDestroy() {
    clearTimeout(this.timeout);
  },

  methods: {
    onClick() {
      const input = document.createElement('input');
      input.setAttribute('readonly', '');
      input.value = this.text;
      input.style.cssText = 'position:fixed;pointer-events:none;z-index:-9999;opacity:0;';
      document.body.appendChild(input);
      input.select();

      try {
        document.execCommand('copy');
      } catch (err) {
        console.warn(err);
      }

      document.body.removeChild(input);
      this.copied = true;
      this.timeout = setTimeout(() => {
        this.copied = false;
      }, 2000);
    }

  }
};

export default script;



// WEBPACK FOOTER //
// ./node_modules/@spartez/vue-atlaskit/dist/components/CopyToClipboard/CopyToClipboard.vue_rollup-plugin-vue=script.js